import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'ca-dialog-header',
    templateUrl: './dialog-header.component.html',
    styleUrl: './dialog-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogTitle, NgTemplateOutlet, MatIconButton, IconComponent]
})
export class DialogHeaderComponent {
    private dialogRef = inject<MatDialogRef<any>>(MatDialogRef);

    @Input() title?: string;
    @Input() titleElement?: TemplateRef<any>;
    @Input() context: any;
    @Output() closed: EventEmitter<void> = new EventEmitter();

    public close() {
        this.closed.emit();
        this.dialogRef.close({ close: true });
    }
}
